module.exports = __webpack_public_path__ + "static/media/instruction_chest.2b95d659.webp";